export default "__VITE_ASSET__DqVvusGf__"